/**
 * Lightning Machine: a 3D, scored walk through GLM-5.3, one late question's trip through a storm of light built
 * around its lightning indexer. three.js is big, so the player loads on its own, only on pages that show it, and never on the
 * server.
 */
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { CSS } from "./story/palette";

const Player = dynamic(() => import("./Player"), {
  ssr: false,
  // The placeholder stands in while the player loads, and stays if it fails to: it says why in the console, as
  // next/dynamic hands it the error and logs nothing itself.
  loading: ({ error }) => {
    if (error) console.error(error);
    return (
      <div
        className="not-prose my-10 relative left-1/2 -translate-x-1/2 w-[min(calc(100vw-2rem),64rem)] aspect-video rounded-xl border"
        style={{ background: CSS.night, borderColor: CSS.steel }}
      />
    );
  }
});

/** Avatar mode (`?avatar`): GLM-5.3's face as a square still for Sam's socials, in place of the player. */
const Avatar = dynamic(() => import("./AvatarMode"), { ssr: false });

export default function LightningMachine() {
  const { query } = useRouter();
  return query.avatar !== undefined ? <Avatar /> : <Player />;
}
